"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var env_1 = require("../../helpers/env");
var csrf = require("../csrfUtils");
// tslint:disable-next-line:no-var-requires
var styles = require('./scene.css');
exports.toggleLike = function () {
    return {
        type: 'TOGGLE_LIKE',
    };
};
exports.setupLikes = function (likes) {
    return {
        type: 'SETUP_LIKES',
        likes: likes,
    };
};
exports.likes = function (state, action) {
    if (state === void 0) { state = { count: 0, hasLiked: false }; }
    switch (action.type) {
        case 'TOGGLE_LIKE':
            return {
                count: !state.hasLiked ? state.count + 1 : state.count - 1,
                hasLiked: !state.hasLiked,
            };
        case 'SETUP_LIKES':
            return action.likes;
        default:
            return state;
    }
};
exports.mapProps = function (state) {
    return {
        likes: state.likes,
        sceneHandle: {
            handle: state.scene.accountId,
            sceneHandle: state.scene.sceneId,
        },
        loginUrl: state.loginUrl,
        userHandle: state.user.handle,
    };
};
exports.mapDispatch = function (dispatch) {
    return {
        toggleLike: function (likes, sceneHandle) {
            dispatch(exports.toggleLike());
            return fetch('/like', {
                method: likes.hasLiked ? 'DELETE' : 'POST',
                credentials: 'same-origin',
                body: JSON.stringify(sceneHandle),
                headers: csrf.withCSRFToken({ 'Content-Type': 'application/json' }),
            })
                .then(function (res) {
                if (res.status !== 200) {
                    dispatch(exports.toggleLike());
                }
            })
                .catch(function (e) {
                dispatch(exports.toggleLike());
            });
        },
    };
};
exports.likeJSX = function (_a) {
    var likes = _a.likes, sceneHandle = _a.sceneHandle, userHandle = _a.userHandle, loginUrl = _a.loginUrl, toggleLike = _a.toggleLike;
    return (React.createElement("a", { className: styles.like, onClick: function () {
            if (!userHandle) {
                return (window.location.href = loginUrl.loginUrl);
            }
            return toggleLike(likes, sceneHandle);
        } },
        React.createElement("div", { className: likes.hasLiked ? styles.liked : '' }, likes.count === 0 ? '' : likes.count),
        React.createElement("img", { src: env_1.env().staticSrcPath() + '/assets/images/icons/like_color.svg' })));
};
exports.LikeButton = react_redux_1.connect(exports.mapProps, exports.mapDispatch)(exports.likeJSX);
